import { Component, OnInit, Input } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { ProjectService } from '../shared/services/project.service';
import { IProject } from '../shared/models/iproject'

@Component({
  selector: 'app-projects-list',
  templateUrl: './projects-list.component.html',
  styleUrls: ['./projects-list.component.scss']
})
export class ProjectsListComponent implements OnInit {

  @Input() amount: number;
  public projects: Array<IProject>;

  constructor(private _projectService: ProjectService) { }

  ngOnInit() {
    this.getProjects(this.amount);

    window.addEventListener('resize', ev => {
      this.resizeProjects();
    });
  }

  getProjects(amount: number) {
    this._projectService.getProjects(amount).subscribe(
      data => { this.projects = this.getRandomProjects(amount, data); },
      err => console.error(err),
      () => this.resizeProjects()
    );
  }

  getRandomProjects(amount: number, data: Array<IProject>) {
    const items: Array<IProject> = new Array<IProject>();
    for (let i = 0; i < amount; i++) {
      items.push(data.splice(Math.round(Math.random() * data.length), 1)[0]);
    }
    return items;
  }

  resizeProjects() {
    window.setTimeout(
      () => {
        const projectsElements = document.querySelectorAll('.project');
        if (projectsElements) {
          let maxHeight = 0;

          [].forEach.call(projectsElements, (project) => {
            project.querySelector('.mat-card-header').style.height = `auto`;
          });

          [].forEach.call(projectsElements, (project) => {
            const h = project.querySelector('.mat-card-header').clientHeight;
            if (h > maxHeight) {
              maxHeight = h;
            }
          });

          if (window.innerWidth >= 480) {
            [].forEach.call(projectsElements, (project) => {
              project.querySelector('.mat-card-header').style.height = `${maxHeight}px`;
            });
          }
        }
      },
      375
    );
  }

}



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/projects/projects-list/projects-list.component.ts